import { render, staticRenderFns } from "./CreateLeave.vue?vue&type=template&id=6d3bf0e4&"
import script from "./CreateLeave.vue?vue&type=script&lang=js&"
export * from "./CreateLeave.vue?vue&type=script&lang=js&"
import style0 from "./CreateLeave.vue?vue&type=style&index=0&id=6d3bf0e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports